import { Navigate, Outlet } from "react-router";
import { getRuntimeConfig } from "@shared-core/config/runtime-config";
import { PREVIEW_BASE } from "./previewSignIn";

// The click-through routes of the new sign-in (mock-up phase). Each page is loaded lazily, so the mock sign-in server
// stays out of the portal's entry bundle, and every route is refused where a real API is configured: the mock has no
// business in a real build.

/** Refuses the routes beneath it where a real API is configured. */
function MockOnly() {
  return getRuntimeConfig().apiBaseUrl ? (
    <Navigate to="/" replace />
  ) : (
    <Outlet />
  );
}

const signInPage = async () => ({
  Component: (await import("./SignInPreviewPage")).SignInPreviewPage,
});

export const previewSignInRoutes = [
  {
    path: PREVIEW_BASE,
    Component: MockOnly,
    children: [
      { index: true, lazy: signInPage },
      { path: "link/:token", lazy: signInPage },
      { path: "invite/:token", lazy: signInPage },
      {
        path: "choose",
        lazy: async () => ({
          Component: (await import("./ChoosePreviewPage")).ChoosePreviewPage,
        }),
      },
      {
        path: "signed-out",
        lazy: async () => ({
          Component: (await import("./SignedOutPreviewPage"))
            .SignedOutPreviewPage,
        }),
      },
      {
        path: "home",
        lazy: async () => ({
          Component: (await import("./HomePreviewPage")).HomePreviewPage,
        }),
      },
      {
        path: "account",
        lazy: async () => ({
          Component: (await import("./AccountPreviewPage")).AccountPreviewPage,
        }),
      },
    ],
  },
];
